import React from 'react'
import { WHATSAPP_NUMBER } from '@constants/contact'
import Header from '@components/Header/Header'
import Sidebar from '@components/Sidebar/Sidebar'
import { BsChevronRight, BsQuestionCircleFill } from 'react-icons/bs'
import { FaInfoCircle, FaWhatsapp } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import '@resources/css/tabs/faq.css'
import { Accordion } from 'react-bootstrap'

interface FaqItem {
  question: string
  answer: string
}

const faqData: FaqItem[] = [
  {
    question: 'Já escolhi meu doador, e agora?',
    answer: `Que ótimo!! Adicione seu(s) doador(es) preferido(s) ao carrinho e faça sua solicitação de pré-reserva!

O processo de aquisição de uma amostra de sêmen tem algumas etapas:

1) Escolha do doador e verificação da disponibilidade/ pré-reserva;
2) Pagamento da amostra e do transporte;
3) Preenchimento das declarações do contrato e assinatura digital
4) Solicitação do envio da amostra pela sua clínica
5) Amostra é entregue em até 48h na clínica.

Todas essas etapas são realizadas aqui pelo Portal, na aba “Pedidos”`
  },
  {
    question: 'Posso ver as fotos dos doadores?',
    answer: `Depende do tipo de doador! 

Doadores Nacionais: Por lei os doadores nacionais precisam ser completamente anônimos e infelizmente somos proibidos de compartilhar fotos (de criança ou adulto)! Nenhum Banco de Sêmen nacional pode revelar as fotos dos doadores brasileiros.

Doadores Internacionais: Nossos bancos parceiros disponibilizam fotos de infância de todos os doadores e alguns doadores americanos (do Seattle Sperm Bank) também tem fotos de adulto! 

Ainda assim, oferecemos e recomendamos o serviço de photo matching! Através deste serviço gratuito, comparamos as opções de doadores pré-selecionados com as fotos que você nos enviar como referência e informamos qual doador mais se aproxima das características desejadas.

Como fazer:

1) Você deve pré-selecionar 3 doadores do mesmo banco e incluir no carrinho
2) Incluir o photomatching durante o checkout
3) Encaminhe as fotos de referência (de com quem você queira que o doador seja parecido fisicamente)
4) Aguarde o retorno por e-mail em até 2 dias úteis com os resultados e doadores semelhantes.`
  },
  {
    question: 'Quais as formas de pagamento?',
    answer: `Facilidades para pagamento:

•⁠ ⁠PIX: 5% de desconto 
•⁠ ⁠Cartão de crédito: parcelamento em até 12x, sendo em até 3x sem juros 

** O método escolhido para pagamento, assim como simulações e taxas devem ser confirmada etapa de pagamento do Portal ou com o setor financeiro no ato da compra.`
  },
  {
    question: 'Quantos dias demora para chegar na minha clínica?',
    answer: `Contamos com o prazo de entrega mais rápido do mercado!! Após confirmação de pagamento e assinatura do contrato digital, entraremos em contato com a clínica para solicitar o de envio da amostra com a data estipulada por eles. A partir dessa data de retirada, a amostra será entregue na clínica em até 48h!

Por segurança, orientamos que a amostra esteja na clínica com pelo menos 10 dias de antecedência do dia do seu procedimento, ok?`
  },
  {
    question: 'O que é o photomatching?',
    answer: `Oferecemos e recomendamos o serviço de "photo matching"!

Através deste serviço gratuito comparamos as opções de doadores pré-selecionados com as fotos que você nos enviar como referência e informamos qual doador mais se aproxima das características desejadas.

Como fazer:

1) Você deve pré-selecionar no mínimo 3 doadores (do mesmo banco de origem) e inseri-los no carrinho
2) Inicie uma solicitação de pré-reserva e inclua o photomatching no “checkout”
3) Envie as fotos de referência (de com quem você queira que o doador seja parecido fisicamente)
4) Aguardar o retorno por e-mail em até 2 dias úteis com os resultados e doadores semelhantes.`
  },
  {
    question: 'O que é e para que serve o mapeamento genético?',
    answer: `Realizamos o painel de mapeamento genético mais completo do mercado em nossos doadores, o CGT Exome. O propósito desse mapeamento é que ele seja usado na análise de compatibilidade genética (matching) com a receptora, para identificar mutações genéticas recessivas em comum que poderiam aumentar o risco (25%) de transmissão e manifestação de doenças genéticas a seus filhos. 
Lembramos que o mapeamento genético do doador é só metade da informação necessária para essa análise! Então, caso queira fazer o matching genético você também precisará fazer o teste e este tem um custo, que precisa ser verificado diretamente com o laboratório de genéica! 
O resultado costuma demorar em torno de 30 dias + 7 dias para o matching!`
  },
  {
    question: 'Qual a diferença de pronta entrega e importação personalizada?',
    answer: `Temos, aqui no Pro-Seed, amostras de doadores nacionais, americanos e europeus, já à pronta entrega, com o prazo de até 48h para entrega direto na clínica onde você fará o procedimento. Selecionar amostras à pronta entrega são ideais para quem tem um prazo mais curto para iniciar o tratamento, além de terem preços muito competitivos! 

Caso você não encontre o perfil ideal dentre as milhares de opções de doadores que temos à pronta entrega, também realizamos importações personalizadas! 

Para a importação personalizada, direcionaremos você aos sites e catálogos completos dos nossos Bancos parceiros para fazer a busca de doadores! Seu pedido será incluso em nosso próximo lote de importação e o prazo de recebimento no Brasil e de, aproximadamente, 50 dias.

Importante! Recomendamos que inicie o processo somente quando a amostra chegar na clínica.`
  },
  {
    question: 'Qual a diferença entre FIV e ICSI?',
    answer: `A ICSI (injeção intracitoplasmática de espermatozoides) é um tipo de FIV, onde a fertilização acontece pela injeção de um único espermatozoide em cada óvulo disponível. Já que os espermatozoides são altamente selecionados, esse tipo de procedimento não requer amostras de sêmen tão concentradas quanto os outros, viabilizando um custo mais competitivo para essas amostras.
Não recomendamos a utilização de amostras de ICSI para tratamentos de FIV clássica.

Na Fertilização in Vitro (ou FIV clássica) a fertilização dos óvulos acontece em laboratório. Os óvulos e espermatozoides previamente selecionados são colocados em uma placa de cultivo e espera-se a fertilização natural. Os óvulos ficam expostos a milhões de espermatozoides e um deles consegue penetrar o óvulo sozinho e fecundá-lo.
Amostras de FIV podem ser utilizadas para procedimentos ICSI.

Já que a ICSI é um tipo de FIV, muitas clínicas acabam generalizando o conceito dizendo que o tratamento será FIV. É importante que você confirme com a sua clínica ou seu médico qual será o tratamento específico que você fará - ICSI ou FIV!`
  },
  {
    question: 'O que é ID aberto (ou ID Release)?',
    answer: `Os bancos de sêmen internacionais disponibilizam dois tipos de doadores: anônimos e de ID aberto. 

Para doadores do Seattle Sperm Bank: o doador ID Aberto concordou em ter pelo menos uma forma de contato com a criança nascida de sua doação quando a criança completar 18 anos.

Para doadores do European Sperm Bank: doadores ID Release que deram permissão para que alguns dados da sua identidade fossem revelados à criança quando ela atingir a maioridade, 18 anos.
Somente a criança poderá obter as informações do doador através do banco de sêmen de onde a amostra foi importada.

Importante: Apesar de nos permitirem importar doadores de ID Aberto, o entendimento atual da ANVISA não libera a revelação da identidade dos doadores Open ID. Mas até a futura criança completar 18 anos isso pode mudar!`
  },
  {
    question: 'Posso usar a mesma amostra quantas vezes?',
    answer: `Recomendamos sempre que 1 amostra = 1 tratamento.
O ideal é que a amostra seja utilizada por completo para o tratamento em questão, aumentando a taxa de sucesso dele! 
Conta indicamos o fracionamento ou recongelamento de amostras, e não garantimos a qualidade de amostras que não foram utilizadas em sua totalidade para um único tratamento.`
  },
  {
    question: 'Quais as formas de atendimento?',
    answer: `Contamos com uma equipe de biomédicas especializadas no atendimento personalizado para te apoiar na jornada de escolha do seu doador ideal! Você pode escolher, dentre as opções abaixo, como quer ser atendida:
- WhatsApp exclusivo: dedicado ao atendimento humano e ágil para esclarecer todas as suas dúvidas e te auxiliar na seleção de doadores e processo de aquisição das amostras! 
- Escolha Monitorada: atendimento online, sendo uma sessão personalizada com especialistas para acompanhar a navegação nos catálogos e auxiliar na seleção dos doadores
- Visita e Orientação Presencial: atendimento presencial, sob agendamento, em nossa sede em São Paulo, sendo uma oportunidade para entender todo o processo, conhecer a nossa equipe e fazer um tour pela infraestrutura do Maior Banco de Sêmen da América Latina! Será um prazer recebê-la!`
  }
]

const Faq: React.FC<any> = () => {
  return (
    <div className="faq d-lg-flex justify-content-lg-center">
      <Sidebar />
      <main className="with-fixed-nav">
        <Header showSidebarOpenButton />
        <div className="row mt-4">
          <div className="col-auto pr-0">
            <Link to="/" className="text-body d-flex align-items-center">Catálogo</Link>
          </div>
          <div className="col-auto pl-1 pr-1">
            <BsChevronRight size={10} />
          </div>
          <div className="col-auto p-0">
            <a href="#" className="id d-flex align-items-center font-weight-bold">
              FAQ
            </a>
          </div>
        </div>
        <section className="faq-hero text-center my-5">
          <div className="faq-hero-icon">
            <BsQuestionCircleFill size={32} />
          </div>
          <h1 className="faq-hero-title mt-3">Perguntas Frequentes</h1>
          <p className="faq-hero-subtitle">Encontre respostas para as dúvidas mais comuns sobre nossos serviços</p>
        </section>

        <section className="mb-4">
          <Accordion defaultActiveKey="0">
            {faqData.map((item, index) => (
              <Accordion.Item key={index} eventKey={index.toString()}>
                <Accordion.Header>
                  <div className="w-100">
                    <span className="text-left">{item.question}</span>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  {item.answer.split('\n').map((paragraph, pIndex) => (
                    <p key={pIndex} className="mb-1">{paragraph}</p>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </section>

        <div className="row">
          <div className="col-12 mt-1">
            <div className="box payment p-4 mb-0 shadow-sm border-0" style={{
              borderRadius: '12px',
              background: 'linear-gradient(135deg, rgb(77, 97, 170) 0%, rgb(107, 127, 193) 100%)',
              color: '#fff'
            }}
            >
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="text flex-grow-1 mb-3 mb-md-0">
                  <div className="d-flex align-items-center mb-2">
                    <div className="d-flex align-items-center justify-content-center" style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '10px',
                      backgroundColor: 'rgba(255, 255, 255, 0.2)',
                      marginRight: '14px'
                    }}
                    >
                      <FaInfoCircle size={20} className="text-white" />
                    </div>
                    <h5 className="mb-0 font-weight-bold text-white">Ainda tem dúvidas?</h5>
                  </div>
                  <p className="mb-0 text-white" style={{ marginLeft: '54px', opacity: 0.95, lineHeight: '1.5' }}>
                  Nossa equipe está pronta para ajudar você em todas as etapas do processo
                  </p>
                </div>
                <a
                  target="_blank"
                  href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá! Gostaria de tirar uma dúvida.')}`}
                  rel="noreferrer"
                  className="btn btn-light btn-lg px-5 py-3"
                  style={{
                    borderRadius: '10px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    textDecoration: 'none',
                    transition: 'all 0.2s',
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    minWidth: '285px'
                  }}
                >
                  <div className="d-flex align-items-center">
                    <FaWhatsapp size={20} className="mr-2" style={{ color: '#25D366' }} />
                    Falar no WhatsApp
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Faq